export default __webpack_public_path__ + "static/media/acms-bom.930d49c4.svg";